import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const NoRemindersSplashIcon = (props: IconProps) => (
  <Icon height="270px" width="265px" viewBox="0 0 270 265" {...props}>
    <ellipse
      opacity="0.6"
      cx="131.855"
      cy="116.786"
      rx="111.845"
      ry="111.786"
      fill="#F5F5F5"
    />
    <path
      d="M98.0189 233.776L94.6545 233.249C93.9434 233.138 93.4426 232.492 93.5127 231.776L96.994 196.094L107.166 197.687L99.5568 232.723C99.4042 233.426 98.7294 233.888 98.0183 233.776L98.0189 233.776Z"
      fill="#282644"
    />
    <path
      d="M202.78 211.229L205.629 209.365C206.231 208.971 206.422 208.176 206.063 207.553L188.196 176.465L179.581 182.101L200.944 210.902C201.373 211.479 202.178 211.623 202.78 211.229L202.78 211.229Z"
      fill="#282644"
    />
    <path
      d="M117.744 70.937C116.492 71.2064 115.258 70.4104 114.988 69.1593L113.053 60.1743C112.783 58.9232 113.58 57.6902 114.832 57.4208C116.083 57.1513 117.317 57.9473 117.587 59.1984L119.523 68.1841C119.792 69.4352 118.996 70.6682 117.744 70.9376L117.744 70.937Z"
      fill="#282644"
    />
    <path
      d="M119.753 53.9916L108.935 56.32C108.017 56.5176 107.433 57.4215 107.631 58.3389L108.168 60.8309C108.365 61.7483 109.27 62.3319 110.188 62.1343L121.006 59.8059C121.924 59.6084 122.508 58.7045 122.31 57.787L121.773 55.295C121.576 54.3776 120.671 53.794 119.753 53.9916Z"
      fill="#E94545"
    />
    <path
      d="M83.1296 96.0676C81.6747 97.5272 79.3115 97.5319 77.851 96.0779L56.6984 75.333C55.2379 73.8791 55.2333 71.5174 56.6883 70.0578C58.1432 68.5981 60.5064 68.5935 61.9669 70.0474L83.1189 90.7925C84.5794 92.2464 84.5839 94.6081 83.129 96.0677L83.1296 96.0676Z"
      fill="#282644"
    />
    <path
      d="M87.1669 68.9715L56.3956 100.773L51.5692 96.109C47.6351 92.3068 47.5299 86.0367 51.3348 82.1049L68.3281 64.5427C72.133 60.6109 78.4071 60.5055 82.3412 64.3077L87.1675 68.9714L87.1669 68.9715Z"
      fill="#E94545"
    />
    <path
      d="M159.639 79.6007C161.567 80.3324 163.722 79.3645 164.454 77.4386L175.189 49.8308C175.921 47.9049 174.953 45.7507 173.025 45.0189C171.098 44.2872 168.943 45.2551 168.21 47.181L157.476 74.7888C156.744 76.7147 157.712 78.8689 159.639 79.6007Z"
      fill="#282644"
    />
    <path
      d="M144.801 56.5671L185.942 72.8909L188.42 66.6551C190.44 61.5715 187.954 55.8138 182.867 53.7957L160.147 44.781C155.06 42.7629 149.298 45.2478 147.279 50.3314L144.801 56.5672L144.801 56.5671Z"
      fill="#E94545"
    />
    <path
      d="M148.122 211.937C188.157 203.32 213.623 163.902 205.003 123.893C196.383 83.8851 156.941 58.4369 116.907 67.0533C76.8723 75.6698 51.4058 115.088 60.0257 155.096C68.6457 195.105 108.088 220.553 148.122 211.937Z"
      fill="#E94545"
    />
    <path
      d="M145.336 199.005C178.214 191.928 199.128 159.557 192.049 126.701C184.97 93.8443 152.579 72.9454 119.701 80.0215C86.8235 87.0977 65.9095 119.469 72.9885 152.326C80.0675 185.182 112.459 206.081 145.336 199.005Z"
      fill="white"
    />
    <path
      d="M121.429 81.1687L118.6 81.7775C117.884 81.9317 117.428 82.6368 117.582 83.3525L119.873 93.9821C120.027 94.6978 120.732 95.153 121.449 94.9989L124.278 94.39C124.994 94.2359 125.449 93.5307 125.295 92.815L123.005 82.1855C122.851 81.4698 122.145 81.0145 121.429 81.1687Z"
      fill="#282644"
    />
    <path
      d="M74.1312 150.607L74.7403 153.435C74.8945 154.15 75.6001 154.606 76.3163 154.451L86.9527 152.162C87.6689 152.008 88.1244 151.303 87.9702 150.587L87.3611 147.76C87.2069 147.044 86.5013 146.589 85.7852 146.743L75.1487 149.032C74.4326 149.186 73.977 149.892 74.1312 150.607Z"
      fill="#282644"
    />
    <path
      d="M143.612 197.871L146.441 197.262C147.157 197.108 147.613 196.403 147.459 195.687L145.168 185.058C145.014 184.342 144.309 183.887 143.592 184.041L140.763 184.65C140.047 184.804 139.592 185.509 139.746 186.225L142.036 196.855C142.19 197.57 142.896 198.026 143.612 197.871Z"
      fill="#282644"
    />
    <path
      d="M190.909 128.432L190.3 125.605C190.146 124.889 189.44 124.434 188.724 124.588L178.088 126.877C177.372 127.031 176.916 127.736 177.07 128.452L177.679 131.279C177.834 131.995 178.539 132.45 179.255 132.296L189.892 130.007C190.608 129.853 191.064 129.147 190.909 128.432Z"
      fill="#282644"
    />
    <path
      d="M94.4249 96.3247L93.3104 97.3329C93.0686 97.5517 93.05 97.9249 93.2689 98.1665L99.1411 104.649C99.36 104.891 99.7335 104.91 99.9753 104.691L101.09 103.683C101.332 103.464 101.35 103.091 101.131 102.849L95.259 96.3661C95.0401 96.1245 94.6667 96.1059 94.4249 96.3247Z"
      fill="#ADADAD"
    />
    <path
      d="M77.9284 121.142L77.4676 122.572C77.3677 122.882 77.5383 123.215 77.8488 123.315L86.1779 125.995C86.4884 126.094 86.8211 125.924 86.9211 125.614L87.3818 124.184C87.4818 123.873 87.3112 123.541 87.0007 123.441L78.6715 120.761C78.3611 120.661 78.0284 120.832 77.9284 121.142Z"
      fill="#ADADAD"
    />
    <path
      d="M96.6788 170.902L97.6868 172.014C97.9057 172.256 97.887 172.63 97.6455 172.849L91.1583 178.717C90.9161 178.936 90.5424 178.917 90.3237 178.676L89.3157 177.563C89.0968 177.321 89.1154 176.947 89.357 176.729L95.8441 170.86C96.0863 170.641 96.46 170.66 96.6788 170.902Z"
      fill="#ADADAD"
    />
    <path
      d="M114.149 194.048L115.579 194.508C115.89 194.608 116.223 194.437 116.323 194.127L119.005 185.803C119.105 185.493 118.934 185.16 118.624 185.061L117.193 184.6C116.882 184.5 116.549 184.671 116.45 184.981L113.767 193.305C113.667 193.615 113.838 193.948 114.149 194.048Z"
      fill="#ADADAD"
    />
    <path
      d="M170.604 182.665L171.719 181.657C171.961 181.438 171.979 181.065 171.76 180.823L165.888 174.34C165.669 174.099 165.296 174.08 165.054 174.299L163.94 175.307C163.698 175.526 163.679 175.899 163.898 176.141L169.77 182.624C169.989 182.865 170.363 182.884 170.604 182.665Z"
      fill="#ADADAD"
    />
    <path
      d="M177.648 154.805L178.109 153.376C178.208 153.066 178.541 152.895 178.852 152.995L187.181 155.675C187.492 155.775 187.663 156.107 187.562 156.418L187.102 157.847C187.002 158.158 186.669 158.329 186.358 158.228L178.029 155.548C177.719 155.449 177.548 155.116 177.648 154.805Z"
      fill="#ADADAD"
    />
    <path
      d="M175.715 101.427L174.706 100.314C174.487 100.072 174.114 100.053 173.872 100.272L167.384 106.141C167.143 106.36 167.124 106.733 167.343 106.975L168.352 108.088C168.571 108.33 168.944 108.348 169.186 108.13L175.673 102.261C175.915 102.042 175.934 101.669 175.715 101.427Z"
      fill="#ADADAD"
    />
    <path
      d="M150.882 84.942L149.451 84.4816C149.141 84.3818 148.808 84.5523 148.708 84.8626L146.026 93.1866C145.926 93.4968 146.097 93.8293 146.407 93.9292L147.838 94.3896C148.149 94.4895 148.481 94.319 148.581 94.0087L151.263 85.6847C151.363 85.3744 151.193 85.0419 150.882 84.942Z"
      fill="#ADADAD"
    />
    <path
      d="M137.597 142.796C139.407 139.994 138.601 136.256 135.798 134.447C132.994 132.638 129.254 133.443 127.444 136.245C125.634 139.047 126.439 142.785 129.243 144.594C132.046 146.402 135.786 145.597 137.597 142.796Z"
      fill="#848484"
    />
    <path
      d="M77.6915 136.347L77.6469 137.243C77.6224 137.736 77.8342 138.15 78.1217 138.17L143.841 142.403L144.071 137.774L78.2559 135.472C77.9678 135.463 77.7155 135.855 77.6915 136.347Z"
      fill="#282644"
    />
    <path
      d="M149.269 178.214L147.577 178.902C147.204 179.054 146.777 178.878 146.618 178.507L125.724 129.665L130.496 127.723L149.678 177.261C149.824 177.637 149.641 178.062 149.268 178.214L149.269 178.214Z"
      fill="#282644"
    />
    <path
      d="M136.249 150.872L133.798 151.4L121.364 90.9272C121.332 90.7759 121.536 90.6043 121.817 90.5437L122.107 90.4813C122.389 90.4207 122.645 90.4934 122.679 90.6441L136.25 150.872L136.249 150.872Z"
      fill="#E94545"
    />
    <path
      d="M137.192 139.285C137.06 136.709 134.863 134.728 132.286 134.86C129.708 134.992 127.725 137.187 127.857 139.763C127.989 142.339 130.186 144.321 132.763 144.189C135.341 144.057 137.324 141.861 137.192 139.285Z"
      fill="#ADADAD"
    />
  </Icon>
);

export default memo(NoRemindersSplashIcon);
